<script setup lang="ts">
import FormFornecedor from '../components/form-fornecedor.vue'
import { useFornecedorStore } from '../store/useFornecedorStore'

definePage({
  meta: {
    navActiveLink: 'admin-fornecedor',
    action: 'create',
    subject: 'fornecedor',
  },
})

const { resetForm } = useFornecedorStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormFornecedor />
</template>
